<template>
  <div class="item-box-content">
    <div class="title-font-style">
      <span>收货信息</span>
    </div>
    <el-form label-width="85px">
      <el-row style="margin-top:20px;">
        <el-col :span="8">
          <el-form-item label="收货人：">
            <el-row :gutter="10">
              <el-col :span="15">
                <el-consignee
                  :InfoList="contractOverview.customerRecevieInfoList"
                  ref="consigneeRefs"
                  @changeName="changeName"
                  :params="queryParams"
                  v-show="contractOverview.signState===1"
                ></el-consignee>
                <span v-show="contractOverview.signState!==1">{{queryParams.receiveName||'--'}}</span>
              </el-col>
              <el-col :span="6" v-if="contractOverview.signState===1">
                <el-button @click="onAddConsignee" type="primary" plain>添加收货人</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话：">
            <span>{{queryParams.receivePhone||'--'}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收货地址：">
            <span>{{(queryParams.receiveAddress||'')+' '+(queryParams.receiveInfo||'--')}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-------------- 添加收货人 -------------->
    <add-consignee-dialog @getCustomer="getCustomer" :id="cusId" ref="addConsigneeDialogRefs"></add-consignee-dialog>
  </div>
</template>
<script>
import editConsigneeDialog from '../../dialog/editConsigneeDialog'
import Consignee from '@/components/Consignee/index'
export default {
  props: ['cusId', 'orderContractReceive', 'contractOverview'],
  components: {
    'add-consignee-dialog': editConsigneeDialog,
    'el-consignee': Consignee
  },
  watch: {
    orderContractReceive: {
      handler (newVal) {
        if (newVal) {
          // if (this.contractOverview.signState === 1) {
          //   this.$refs.consigneeRefs.onConsignee(this.cusId, null, true)
          // }
          newVal.crName = newVal.receiveName
          newVal.crPhone = newVal.receivePhone
          newVal.crAddress = newVal.receiveInfo
          this.queryParams = JSON.parse(JSON.stringify(newVal))
        }
      },
      deep: true
    }
  },
  data () {
    return {
      queryParams: {
        receivePhone: '',
        receiveAddress: '',
        receiveInfo: ''
      }
    }
  },
  methods: {
    // 添加以后刷新数据
    getCustomer (obj) {
      this.consigneeParams = obj
      this.$refs.consigneeRefs.onConsignee(this.cusId, obj.id)
    },
    // 添加收货人
    onAddConsignee () {
      this.$refs.addConsigneeDialogRefs.onInitial('添加收货人')
    },
    // 获取选择的收货人
    changeName (item) {
      item.receiveName = item.crName
      item.receiveAddress = item.crProvince
      item.receiveInfo = item.crAddress
      item.receivePhone = item.crPhone || item.customerRecevieMobileVoList[0].crPhone
      this.queryParams = item
    }
  }
}
</script>
